import { capture } from "./capture";

export const SummaryTracking = {
  /** Summary data fetch failed (savings breakdown). */
  dataFetchFailed: (error: unknown) => {
    capture("summary.data_fetch_failed", { error: String(error) });
  },

  /** Cost breakdown API error. */
  costBreakdownLoadFailed: (error: unknown) => {
    capture("summary.cost_breakdown_load_failed", { error: String(error) });
  },

  /** Savings breakdown API error. */
  savingsBreakdownLoadFailed: (error: unknown) => {
    capture("summary.savings_breakdown_load_failed", { error: String(error) });
  },

  /** Opportunities list fetch failed. */
  opportunitiesLoadFailed: (error: unknown) => {
    capture("summary.opportunities_load_failed", { error: String(error) });
  },

  /** User created a new report subscription. */
  reportSubscriptionCreated: (props: {
    emails_count: number;
    interval: string;
    enable_rca: boolean;
  }) => {
    capture("summary.report_subscription_created", props);
  },

  /** User edited an existing report subscription. */
  reportSubscriptionEdited: (props: {
    subscription_id: string;
    interval: string;
  }) => {
    capture("summary.report_subscription_edited", props);
  },

  /** User deleted a report subscription. */
  reportSubscriptionDeleted: (props: { subscription_id: string }) => {
    capture("summary.report_subscription_deleted", props);
  },

  /** User opened the summary chatbot. */
  chatbotOpened: (props: { analysis_type: string }) => {
    capture("summary.chatbot_opened", props);
  },

  /** User opened the chart chatbot via the AI button. */
  chartChatbotOpened: (props: { chart_type: string; cost_type: string }) => {
    capture("summary.chart_chatbot_opened", props);
  },

  /** User clicked on an opportunity card. */
  opportunityClicked: (props: {
    opportunity_label: string;
    savings_amount: number;
  }) => {
    capture("summary.opportunity_clicked", props);
  },
};
